import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import nodata from "../../image/errors/500.png";

const PageLoader = () => {
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000); // Auto-hide after 3 seconds

    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f4f4f4",
      }}
    >
      <div
        style={{
          width: "50px",
          height: "50px",
          border: "5px solid rgba(0, 0, 0, 0.1)",
          borderTopColor: "#007bff",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      ></div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};



const StyledBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  textAlign: "center",
  padding: "20px",
});

const StyledImage = styled("img")({
  width: "50%",
  maxWidth: "400px",
  animation: "float 3s infinite ease-in-out",
  "@keyframes float": {
    "0%": { transform: "translateY(0px)" },
    "50%": { transform: "translateY(-10px)" },
    "100%": { transform: "translateY(0px)" },
  },
});

export const ServerError = () => {
  const navigate = useNavigate();

  return (
    <>
    <PageLoader />
    <StyledBox>
      <StyledImage src={nodata} alt="Page Not Found" />
      <Typography variant="h4" fontWeight="bold" mt={3}>
        Oops! Page Not Found
      </Typography>
      <Typography variant="body1" mt={2} sx={{ opacity: 0.8, maxWidth: "500px" }}>
        The link you clicked may be broken, or the page may have been removed.
        Please check the URL or go back to the homepage.
      </Typography>
      <Button
        variant="contained"
        sx={{ mt: 3, px: 4, py: 1.5, fontSize: "16px", borderRadius: "8px" }}
        onClick={() => navigate("/")}
      >
        Go to Homepage
      </Button>
    </StyledBox>
    </>
  );
};
